import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckboxOff = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2.75,
			y: 2.75,
			width: 18.5,
			height: 18.5,
			rx: 1.25,
			stroke: "url(#paint0_linear_2380_22885)",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.75,
			y: 2.75,
			width: 18.5,
			height: 18.5,
			rx: 1.25,
			stroke: "#103C43",
			strokeOpacity: .1,
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_2380_22885",
			x1: 2,
			y1: 2,
			x2: 20.0566,
			y2: 23.6229,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E6F3F9" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#E6F9F6"
			})]
		}) })
	]
});
export default SvgCheckboxOff;
